import { useSelector, useDispatch } from "react-redux";
import { close } from "../../redux-state/bannerNotificationHandler.js";
import { useEffect } from "react";

function Banner_Notification() {
  const dispatch = useDispatch();
  let bannerMessage = useSelector((state) => state.bannerHandler.message);
  let bannerClass = useSelector((state) => state.bannerHandler.classType);
  useEffect(() => {
    setTimeout(function () {
      dispatch(close());
    }, 3000);
  }, []);

  return (
    <div id="banner-container">
      <div id="banner-notification" className={bannerClass}>
        <p>{bannerMessage}</p>
        <span
          className="material-symbols-outlined close clickable"
          onClick={() => dispatch(close())}
        >
          close
        </span>
      </div>
    </div>
  );
}
export default Banner_Notification;
